import { render, staticRenderFns } from "./create-company.component.html?vue&type=template&id=2b63774d&scoped=true&"
import script from "./create-company.component.ts?vue&type=script&lang=ts&"
export * from "./create-company.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-company.component.scss?vue&type=style&index=0&id=2b63774d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63774d",
  null
  
)

export default component.exports